import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";

// Correzione dei dati di fatturazione di un'azienda (PATCH /admin/organizations/{id}).
// Riusabile dalla scheda cliente. La creazione azienda (Fase C) userà un flusso
// dedicato che crea org + account insieme.
export default function OrgFormDialog({ open, onOpenChange, org, onSaved }) {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && org) {
      setForm({
        ragione_sociale: org.ragione_sociale || "",
        vat_number: org.vat_number || "",
        tax_code: org.tax_code || "",
        sdi_code: org.sdi_code || "",
        pec: org.pec || "",
        phone: org.phone || "",
      });
    }
  }, [open, org]);

  if (!org || !form) return null;

  const setF = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`/admin/organizations/${org.id}`, form);
      toast.success("Dati azienda aggiornati.");
      onSaved?.();
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm">
        <DialogHeader>
          <DialogTitle className="text-brand-blue">Dati azienda</DialogTitle>
          <DialogDescription>Anagrafica e dati di fatturazione.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <Fld label="Ragione sociale" value={form.ragione_sociale} onChange={setF("ragione_sociale")} required />
          <div className="grid grid-cols-2 gap-3">
            <Fld label="Partita IVA" value={form.vat_number} onChange={setF("vat_number")} />
            <Fld label="Codice fiscale" value={form.tax_code} onChange={setF("tax_code")} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Fld label="Codice SDI" value={form.sdi_code} onChange={setF("sdi_code")} />
            <Fld label="PEC" value={form.pec} onChange={setF("pec")} />
          </div>
          <Fld label="Telefono" value={form.phone} onChange={setF("phone")} />
          <DialogFooter>
            <Button type="submit" className="btn-primary" disabled={saving}>
              {saving ? <Loader2 className="animate-spin" size={16} /> : "Salva"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

function Fld({ label, ...props }) {
  return (
    <div>
      <Label className="text-sm text-brand-ink">{label}</Label>
      <Input {...props} className="mt-1.5 h-11 rounded-sm border-brand-line focus-visible:ring-2 focus-visible:ring-brand-blue" />
    </div>
  );
}
